export const GuestsKeyFactory = {
    all: (params) => [
        'workspaces',
        params.workspaceId,
        'filespaces',
        params.filespaceId,
        'guests',
    ],
    exact: (params) => [...GuestsKeyFactory.all(params), 'exact', params.email],
    list: ({ filespaceId, listParams, workspaceId, }) => [
        ...GuestsKeyFactory.all({ filespaceId, workspaceId }),
        'list',
        ...(listParams ? [listParams] : []),
    ],
};
